import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Spacer, Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const IconThreeRow = memo(({ icon, label, subLabel, subSubLabel }) => {
    const theme = useTheme();
    const displayLabel = label || getLiteral('label_placeholder_unamed_record');

    return (
        <div className="fm-select-row--flex fm-select-row--icon-three">
            {icon && (
                <>
                    <div className="fm-select-row__icon">{icon}</div>
                    <Spacer x={2} />
                </>
            )}
            <div className="fm-select-row__content">
                <Text type="body" isTruncated useTooltip>
                    {displayLabel}
                </Text>
                <Text
                    type="body"
                    color={theme.colors.utility.textSecondary}
                    isTruncated
                    useTooltip
                    as="div"
                >
                    {subLabel}
                </Text>
                <Text
                    type="caption"
                    color={theme.colors.utility.textSecondary}
                    isTruncated
                    useTooltip
                    as="div"
                >
                    {subSubLabel}
                </Text>
            </div>
        </div>
    );
});

IconThreeRow.displayName = 'IconThreeRow';

IconThreeRow.propTypes = {
    icon: PropTypes.node,
    label: PropTypes.node,
    subLabel: PropTypes.node,
    subSubLabel: PropTypes.node,
};

export default IconThreeRow;
